import { plantasService, usersService } from '../../services';

export const errorConexionServer = () => async dispatch => {
  dispatch({
    type: 'errorConexionServer',
  });
};
export const initProyectGlovalData = () => async dispatch => {
  dispatch({
    type: 'initGlobal',
  });
};

export const initProyectGlovalData1 = values => async dispatch => {
  dispatch({
    type: 'initGlobal1',
    dataT: values,
  });
};
export const setProyectPlantaVisible = values => async dispatch => {
  dispatch({
    type: 'setPlantaVisible',
    dataT: values,
  });
};
export const setWidgesVisibles = values => async dispatch => {
  dispatch({
    type: 'setWidgesVisibles',
    dataT: values,
  });
};
export const setPlantas = values => async dispatch => {
  dispatch({
    type: 'setPlantas',
    dataT: values,
  });
};
export const setPlantaActual = values => async dispatch => {
  dispatch({
    type: 'setPlantaActual',
    dataT: values,
  });
};
export const setBreadCrumb = values => async dispatch => {
  dispatch({
    type: 'setBreadCrumb',
    dataT: values,
  });
};
export const setIdioma = values => async dispatch => {
  dispatch({
    type: 'setIdioma',
    dataT: values,
  });
};

export const setUserDataFromLocalStorage = values => async dispatch => {
  dispatch({
    type: 'setUserDataFromLocalStorage',
    dataT: values,
  });
};

export const setConfigurationUsers = () => async dispatch => {
  try {
    dispatch({
      type: 'loadingConfiguration',
      dataT: true,
    });
    const users = await usersService.getUsers(true, true);
    dispatch({
      type: 'setConfigurationUsers',
      dataT: users,
    });
    dispatch({
      type: 'setCurrentUser',
      dataT: users[0],
    });
    dispatch({
      type: 'loadingConfiguration',
      dataT: false,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setCurrentUser = user => async dispatch => {
  try {
    dispatch({
      type: 'setCurrentUser',
      dataT: user,
    });
  } catch (e) {
    console.error(e);
  }
};

export const setConfigurationUsersAfterAzureSync = () => async dispatch => {
  try {
    dispatch({
      type: 'loadingConfiguration',
      dataT: true,
    });
    const users = await usersService.syncUsersWithAzure();
    dispatch({
      type: 'setConfigurationUsers',
      dataT: users,
    });
    dispatch({
      type: 'setCurrentUser',
      dataT: users[0],
    });
    dispatch({
      type: 'loadingConfiguration',
      dataT: false,
    });
  } catch (e) {
    console.error(e);
  }
};

export const updateUser =
  (user, includePlantas) => async (dispatch, getState) => {
    try {
      dispatch({
        type: 'loadingConfiguration',
        dataT: true,
      });
      const updatedUser = await usersService.updateUser(user, includePlantas);
      const { users } = getState().proyect.configuration;
      const userIndex = users.findIndex(
        user => user.idusuario === updatedUser.idusuario,
      );
      users[userIndex] = updatedUser;
      dispatch({
        type: 'updateConfigurationUser',
        dataT: {
          users,
          currentUser: updatedUser,
        },
      });
      dispatch({
        type: 'loadingConfiguration',
        dataT: false,
      });
    } catch (e) {
      console.error(e);
      throw new Error(e);
    }
  };

export const updatePlantasUsuarios =
  (currentUser, selectedPlantas) => async (dispatch, getState) => {
    try {
      dispatch({
        type: 'loadingConfiguration',
        dataT: true,
      });
      await plantasService.updatePlantasUsuarios(
        currentUser.idusuario,
        selectedPlantas.map(planta => ({
          idusuario: currentUser.idusuario,
          idplanta: planta.idplanta,
        })),
      );
      const { users } = getState().proyect.configuration;
      const userIndex = users.findIndex(
        user => user.idusuario === currentUser.idusuario,
      );
      const updatedUser = { ...currentUser, plantas: selectedPlantas };
      users[userIndex] = updatedUser;
      dispatch({
        type: 'updateConfigurationUser',
        dataT: {
          users,
          currentUser: updatedUser,
          loading: false,
        },
      });
    } catch (e) {
      console.error(e);
      throw new Error(e);
    }
  };

export const setConfigurationUser = values => async dispatch => {
  dispatch({
    type: 'setConfigurationUser',
    dataT: values,
  });
};

export const setConfigurationPlantas = plantas => async dispatch => {
  dispatch({
    type: 'setConfigurationPlantas',
    dataT: plantas,
  });
};
